const Class1 = () => {
  return (
    <section className="lg:my-8">
      <div className="px-3 sm:px-4 lg:px-16 pt-8 lg:pb-2 bg-beige/60 mx-3 md:mx-8 lg:mx-20 rounded-lg shadow-lg ">
        <h1 className="text-2xl md:text-3xl lg:text-4xl text-center text-brown-700 font-bold mb-10 font-heading">
          Indian Traditional Artforms
        </h1>
        <div className="w-full flex max-md:flex-col">
          {/* Portrait */}
          <div className="mr-5 flex-1 max-md:mx-auto">
            <img
              src="/images/class1_inside.jpg"
              alt="Artist Portrait"
              className="rounded-lg shadow-lg mx-auto lg:mx-0 object-cover w-full"
            />
          </div>
          {/* Text */}
          <div className="text-brown-700 lg:text-lg text-base lg:leading-relaxed leading-5 text-justify flex-[2] max-md:flex-1 font-para font-semibold">
            <p className="lg:mb-6 md:mb-5 mb-4 mt-4">
              India, a land of vibrant cultures and a rich, timeless heritage, is home to an extraordinary array of traditional art forms that have flourished across centuries. Each region boasts its own artistic identity, rooted deeply in its history, mythology, and cultural traditions. From the intricate and colorful Madhubani paintings of Bihar, known for their bold geometric patterns and depictions of nature and mythology, to the regal and resplendent Tanjore paintings of Tamil Nadu, adorned with gold foil and divine imagery, these art forms serve as a testament to the unparalleled diversity and creativity of Indian artistry.
            </p>
            <p className="mb-6">
              At Tvisarts Studio, we bring you the rare opportunity to immerse yourself in this world of traditional Indian art. Our studio offers expert-led workshops where you can learn the techniques, history, and symbolism behind these timeless crafts. Whether it's mastering the meticulous linework and natural dye techniques of Madhubani or understanding the layered painting process and ornate detailing of Tanjore, our hands-on sessions are designed to inspire creativity and a deeper appreciation for these cultural treasures.
            </p>
            <p>
              By the end of your journey at Tvisarts Studio, you won't just have an enriching experience—you'll also take home a masterpiece, crafted by your own hands, and a story to tell of how you contributed to the preservation and celebration of India's artistic legacy. Join us to explore, create, and connect with the soul of India's traditional art!
            </p>
            <div className="flex justify-center mt-8">
            <button className="text-brown-700 text-xl sm:text-2xl font-semibold shadow-inset w-[45%] max-sm:w-[50%] transition-all rounded-lg py-2 hover:shadow-xl hover:bg-beige">
              <a href="/#contactNav">Equire Now</a>
            </button>
            </div>
          </div>
        </div>
        <div className="w-full flex justify-center my-8">

        </div>
      </div>
      <img src="/images/class1_detail.jpg" className="w-11/12 md:2/3 lg:w-3/5 my-8 mx-auto" />
    </section>
  );
};

export default Class1;